Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Builders'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessLocationSummaryBuilder
  setName: (name) =>
    @name = name

  getName: =>
    @name

  setURL: (url) =>
    @url = url

  getURL: =>
    @url

  setLocationName: (locationName) =>
    @locationName = locationName

  getLocationName: =>
    @locationName

  setStoreCode: (storeCode) =>
    @storeCode = storeCode

  getStoreCode: =>
    @storeCode

  setAddress: (address) =>
    @address = address

  getAddress: =>
    @address

  build: =>
    new Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessLocationSummary(@)
